import {Component, forwardRef, OnInit, ChangeDetectorRef, Injector, AfterViewInit} from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { AbstractWorkflowFormComponent } from '../../@core/abstract-workflow-form-component';
import { InputGridFunctionsModel } from '../input-grid-functions.model';
import { takeUntil, filter } from 'rxjs/operators';
import { Model_WorkflowComponent, FORMAT_NUMBER } from 'src/app/app.models';
import { WorkflowComponentsService, EventWorkflowValuesChanged } from '../../workflow-components.service';
import { ExpressionBuilderService } from '../../expression-builder/expression-builder.service';
import {v4 as uuidv4} from 'uuid';
import * as numeral from 'numeral';
import { InputmaskOptions, createMask } from '@ngneat/input-mask';
import { Options } from 'inputmask';

@Component({
    selector: 'abw-input-grid-functions-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => InputGridFunctionsFormComponent),
        multi: true
      },
      {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => InputGridFunctionsFormComponent),
        multi: true
      }
    ],
    templateUrl: './input-grid-functions-form.component.html',
    styleUrls: ['./input-grid-functions-form.component.scss']
})
export class InputGridFunctionsFormComponent extends AbstractWorkflowFormComponent<InputGridFunctionsModel, any> implements AfterViewInit {
  FORMAT_NUMBER = FORMAT_NUMBER;
  inputMaskConfig: InputmaskOptions<any>;
  numericValue: number = 0;
  
  constructor(
    protected _workflowComponentsService: WorkflowComponentsService,
    protected _cdf: ChangeDetectorRef,
    protected _injector: Injector,
    private _expressionBuilderService: ExpressionBuilderService,
  ) {
    super(_workflowComponentsService, _cdf, _injector); 
    this.inputMaskConfig = createMask({
      alias: 'numeric',
      groupSeparator: ' ',
      radixPoint: ',',
      digits: '2',
      digitsOptional: true,
      prefix: '',
      placeholder: '0',
      rightAlign: false,
      onBeforeMask: (initialValue: string, opts: Options) => {
        return initialValue;
      }
    });
  }

  ngAfterViewInit() {
    //this._workflowComponentsService.workflowValuesChanged$.pipe(takeUntil(this.onComplete)).subscribe(async _change => { await this._evaluateValue(_change); });
    this._workflowComponentsService.gridComponentsValuesChanged$.pipe(takeUntil(this.onComplete)).subscribe(async _change => {
      this._evaluateValue(_change);
    });
    this._evaluateValue(this._workflowComponentsService.gridComponentsValuesChanged$.value);
  }

  writeValue(value: any) {
    const numericValue: number = !!value ? parseFloat(value.toString().replace(/\s/g, "").replace(",", ".")) : 0;
    this.value = numericValue; 
    this.numericValue = numericValue;
  }

  onChanged(_event) {
    const value = _event.target.value;
    this.onValueChanged((!!value ? numeral((value + '').replace(',', '.')).value() : 0) + '');
  }

  onValueChanged(_value: any, _emitValue?: boolean, _callersStack?: string[]) {
    const numericValue: number = !!_value ? parseFloat(_value.toString().replace(/\s/g, "").replace(",", ".")) : 0;
    this.value = numericValue; 
    this.numericValue = numericValue;
    this.propagateChange(this.value);
    try { this._cdf.detectChanges(); } catch(ex) {}
    this.change.emit(this.value);
    if (!!this.model && (_emitValue === undefined || _emitValue === true)) {
      this.emitValue(_callersStack);
    }
  }

  private async _evaluateValue(_change: any) {
    const workflowComponent = (this.model as any).additional as Model_WorkflowComponent;
    if (this.model.inputGridId == _change?.sender?.ID || this.model.inputGridId == _change?.sender?.PARENT_GRID_INPUT_ID) {
      let gridDatas: any[] = _change.gridValue;
      if (!!gridDatas) {
        const gridFilters = workflowComponent.INPUT_GRID_FILTERS;
        if (!!gridFilters) {
          const filteredGridDatas: any[] = [];
          for (var r in gridDatas) {
            const gridRow = gridDatas[r];
            const formGroupId = uuidv4();
            const formValues: any = {};
            formValues[formGroupId] = gridRow;

            const isFilterValid = await this._expressionBuilderService.doBuildExpression(gridFilters, {
              eventWorkflowValuesChanged: { formValues: formValues },
              environmentVariables: [],
              initialState: true,
              formGroupId: formGroupId,
            });
            if (isFilterValid == true) {
              filteredGridDatas.push(gridRow);
            }
          }
          gridDatas = filteredGridDatas;
        }

        const gridFunction = workflowComponent.INPUT_GRID_FUNCTION_ID;
        let resultFunction = 0;
        if (gridFunction !== undefined) {
          switch(gridFunction) {
            case 'SUM':
              resultFunction = gridDatas.filter(data => !!data[this.model.inputGridColumnId] && !isNaN(data[this.model.inputGridColumnId])).map(data => parseFloat(data[this.model.inputGridColumnId])).reduce((partialSum, a) => partialSum + a, 0);
              break;

            case 'COUNT':
              resultFunction = gridDatas.length;
              break;
          }
        }
        setTimeout(() => this.onValueChanged(resultFunction), 10);
      }
    }
  }

  /*
  private async _evaluateValue(_change: EventWorkflowValuesChanged) {
    const workflowComponent = (this.model as any).additional as Model_WorkflowComponent;
    let formGroupId = workflowComponent.FORM_ID || '_FORM_';
    if ((!!_change && !!_change.formValues && !!_change.formValues[formGroupId] && !!_change.formValues[formGroupId][this.model.inputGridId]) && (!_change.sender || (_change.sender.PARENT_GRID_INPUT_ID == this.model.inputGridId))) {
      let gridDatas: any[] = _change.formValues[formGroupId][this.model.inputGridId];
      
      if (!!gridDatas) {
        const gridFilters = workflowComponent.INPUT_GRID_FILTERS;
        if (!!gridFilters) {
          const filteredGridDatas: any[] = [];
          for (var r in gridDatas) {
            const gridRow = gridDatas[r];
            const formGroupId = uuidv4();
            const formValues: any = {};
            formValues[formGroupId] = gridRow;

            const isFilterValid = await this._expressionBuilderService.doBuildExpression(gridFilters, {
              eventWorkflowValuesChanged: { formValues: formValues },
              environmentVariables: [],
              initialState: true,
              formGroupId: formGroupId,
            });
            if (isFilterValid == true) {
              filteredGridDatas.push(gridRow);
            }
          }
          gridDatas = filteredGridDatas;
        }

        const gridFunction = workflowComponent.INPUT_GRID_FUNCTION_ID;
        let resultFunction = 0;
        if (gridFunction !== undefined) {
          switch(gridFunction) {
            case 'SUM':
              resultFunction = gridDatas.filter(data => !!data[this.model.inputGridColumnId] && !isNaN(data[this.model.inputGridColumnId])).map(data => parseFloat(data[this.model.inputGridColumnId])).reduce((partialSum, a) => partialSum + a, 0);
              break;

            case 'COUNT':
              resultFunction = gridDatas.length;
              break;
          }
        }
        setTimeout(() => this.onValueChanged(resultFunction), 10);
      }
    }
  }
  */
}